export { DIACRITIC_TONE_DICT, type DiacriticTone } from "#diacritic-tone-dict";
